import { useState, useEffect } from 'react';

import { useRouter, useSearchParams } from 'src/routes/hooks';

import { CONFIG } from 'src/config-global';

import { LoadingScreen } from 'src/components/loadingScreen';

import { useAuthContext } from '../hooks';

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export function GuestGuard({ children }: Props) {
  const router = useRouter();

  const searchParams = useSearchParams();

  const { loading, authenticated, user } = useAuthContext();

  const [isChecking, setIsChecking] = useState<boolean>(true);

  const returnTo = searchParams.get('returnTo') || CONFIG.auth.redirectPath;

  const checkPermissions = async (): Promise<void> => {
    if (loading) {
      return;
    }

    if (authenticated && user) {
      const roleHome = `/${user?.role || '/client'}`;
      const validRoles = ['/administrator', '/client', '/manager', '/teacher'];

      let redirectPath;
      if (!returnTo || returnTo === '/' || !returnTo.startsWith('/')) {
        redirectPath = roleHome;
      } else if (returnTo.startsWith(roleHome)) {
        redirectPath = returnTo;
      } else if (!validRoles.some((role) => returnTo.startsWith(role))) {
        redirectPath = returnTo;
      } else {
        redirectPath = roleHome;
      }
      if (returnTo !== redirectPath) {
        router.replace(redirectPath);
      } else {
        router.replace(returnTo);
      }
      return;
    }

    setIsChecking(false);
  };

  useEffect(() => {
    checkPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, loading]);

  if (isChecking) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
}
